export enum FlightStatusCode {
    GOOD, CARE, DANGER
}

export class FlightStatusName {
    public static convertCodeToClass(statusCode: FlightStatusCode): string | null{
        switch (statusCode) {
            case FlightStatusCode.GOOD :
                return null;
            case FlightStatusCode.CARE :
                return "accent2";
            case FlightStatusCode.DANGER :
                return "accent";
        }
    }
}